import { alpha } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../modules/mp-core/themes/palette"

export const useStyles = makeStyles()(() => ({
  appWideBackgroundColor: {
    backgroundColor: alpha(blueGrey[50], 0.4)
  }
}))
